import { inject, Injectable } from "@angular/core";
import { Order } from "@models/order.model";
import { Api } from "@services/api.service";

@Injectable({
	providedIn: 'root'
})
export class OrderService{
	private api: Api=inject(Api);

	createPlanOrder(){
		return this.api.post<Order>(`/plans/orders`, {});
	}
}